// import { useFormik } from 'formik';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import Select from 'react-select';
// import { Card, CardFooter } from '@components/card/card';
// import { CardBody, Form, Modal } from 'react-bootstrap';
// import { useTranslation } from 'react-i18next';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { useNavigate, useParams } from 'react-router-dom';
// import ItemsList from './ItemsList/ItemsList';
// import { addInventoryCount, updatInventoryCount, getInventoryCountById } from '@store/INV/InventoryCount/inventoryCountSlice';
// import { useEffect, useMemo, useState } from 'react';
// import ToastSwal from '@components/Shared/Alert/ToastSwal';
// import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';
// import { getPersonId } from '@store/Login/authSelectors';
// import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
// import useLookupInventoryCountingTypes from '@hooks/Lookups/use-Lookup-InventoryCountingTypes';

// interface InventoryCountFormData {
//   name: string;
//   name2: string;
//   personId: string | null;
//   inventoryId: string;
//   branchId: string;
//   startDate: string;
//   description: string;
//   freezeDate: string;
//   immediately: boolean;
//   inventoryCountingTypes: string;
//   inventoryCountItemsList: any[];
// }

// const InventoryCountForm = () => {
//   const { id } = useParams(); // ID for update
//   const isEditMode = Boolean(id);

//   const [showModal, setShowModal] = useState(!isEditMode); // Don't show modal in edit mode
//   const [loading, setLoading] = useState(isEditMode);
//   const [initialData, setInitialData] = useState<any>(null);

//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();
//   const navigate = useNavigate();
//   const personId = useAppSelector(getPersonId);

//   const { InventoryCountingTypes } = useLookupInventoryCountingTypes();
//   const { OperatingUnitOptions, loading: loadingOU, error: errorOU } = useGetOperatingUnitWithPermission();
//   const { InventoryOptions, loading: loadingInv } = useGetInventoryWithPermission();

//   const [showItemsList, setShowItemsList] = useState(false);

//   // Fetch data for edit mode
//   useEffect(() => {
//     if (isEditMode && id) {
//       const fetchData = async () => {
//         try {
//           setLoading(true);
//           const result = await dispatch(getInventoryCountById(id)).unwrap();
//           if (result?.succeeded) {
//             setInitialData(result.data);
//           } else {
//             CustomAlert({ action: 'Error', msg: result?.message || 'Failed to load data' });
//             navigate('/INV/InventoryCount');
//           }
//         } catch (error) {
//           CustomAlert({ action: 'Error' });
//           navigate('/INV/InventoryCount');
//         } finally {
//           setLoading(false);
//         }
//       };
//       fetchData();
//     }
//   }, [isEditMode, id, dispatch, navigate]);

//   // Initialize form with data
//   const getInitialValues = (): InventoryCountFormData => {
//     if (isEditMode && initialData) {
//       return {
//         name: initialData.name || '',
//         name2: initialData.name2 || '',
//         personId: initialData.personId || personId,
//         inventoryId: initialData.inventoryId || '',
//         branchId: initialData.branchId || '',
//         startDate: initialData.startDate || '',
//         description: initialData.description || '',
//         freezeDate: initialData.freezeDate || '',
//         immediately: initialData.immediately || false,
//         inventoryCountingTypes: initialData.inventoryCountingTypes || '',
//         inventoryCountItemsList: initialData.inventoryCountItemsList || []
//       };
//     }

//     return {
//       name: '',
//       name2: '',
//       personId: personId,
//       inventoryId: '',
//       branchId: '',
//       startDate: '',
//       description: '',
//       freezeDate: '',
//       immediately: false,
//       inventoryCountingTypes: '',
//       inventoryCountItemsList: []
//     };
//   };

//   //#region Formik
//   const formik = useFormik({
//     initialValues: getInitialValues(),
//     enableReinitialize: true,
//     onSubmit: async (values) => {
//       try {
//         const itemsList = values.inventoryCountingTypes === 'PhysicalInventory'
//           ? []
//           : values.inventoryCountItemsList?.map(item => ({
//               inventoryItemId: item.inventoryItemId,
//               systemQuantity: item.systemQuantity,
//               description: item.description,
//               subInventoryId: item.subInventoryId
//             }));

//         const payload = {
//           name: values.name,
//           name2: values.name2,
//           personId: values.personId,
//           inventoryId: values.inventoryId,
//           branchId: values.branchId,
//           startDate: values.startDate,
//           description: values.description,
//           freezeDate: values.freezeDate,
//           immediately: values.immediately,
//           inventoryCountingTypes: values.inventoryCountingTypes,
//           inventoryCountItemsList: itemsList
//         };

//         let result;
//         if (isEditMode && id) {
//           result = await dispatch(updatInventoryCount({ id, ...payload })).unwrap();
//         } else {
//           result = await dispatch(addInventoryCount(payload)).unwrap();
//         }

//         if (result?.succeeded) {
//           CustomAlert({ action: isEditMode ? 'Edit' : 'Add' });
//           navigate(-1);
//         } else {
//           formik.setSubmitting(false);
//           CustomAlert({ action: 'Error', msg: result?.message });
//         }
//       } catch (error) {
//         formik.setSubmitting(false);
//         CustomAlert({ action: 'Error' });
//       }
//     }
//   });

//   const { values, handleChange, errors, touched, setFieldValue, isSubmitting } = formik;
//   //#endregion

//   // Set first operating unit automatically when data loads (only for add mode)
//   useEffect(() => {
//     if (!isEditMode && !formik.values.branchId && OperatingUnitOptions?.length > 0) {
//       const firstOption = OperatingUnitOptions[0];
//       formik.setFieldValue('branchId', firstOption.value);
//     }
//   }, [OperatingUnitOptions, isEditMode]);

//   // Control items list display based on counting type
//   useEffect(() => {
//     if (values.inventoryCountingTypes === 'CycleCount') {
//       setShowItemsList(true);
//       if (!values.inventoryCountItemsList || values.inventoryCountItemsList.length === 0) {
//         setFieldValue('inventoryCountItemsList', [
//           {
//             inventoryItemId: null,
//             systemQuantity: 0,
//             description: ''
//           }
//         ]);
//       }
//     } else if (values.inventoryCountingTypes === 'PhysicalInventory') {
//       setShowItemsList(false);
//       setFieldValue('inventoryCountItemsList', []);
//     }
//   }, [values.inventoryCountingTypes, setFieldValue]);

//   const handleSubmitModal = () => {
//     if (formik.values.branchId && formik.values.inventoryId && formik.values.inventoryCountingTypes) {
//       setShowModal(false);
//     } else {
//       ToastSwal({ title: t('Please select operating unit, inventory and counting type'), timer: 1000 });
//     }
//   };

//   // Get inventory counting type name
//   const getInventoryCountingTypeName = () => {
//     if (!values.inventoryCountingTypes) return '';

//     let typeName = '';
//     InventoryCountingTypes?.forEach((item: any) => {
//       item.list?.forEach((list: any) => {
//         if (list.lookupCode === values.inventoryCountingTypes) {
//           typeName = i18n.language === 'ar' ? list.meaning2 : list.meaning;
//         }
//       });
//     });
//     return typeName;
//   };

//   const isLoading = useMemo(() => loadingOU || loadingInv || loading, [loadingOU, loadingInv, loading]);

//   // Breadcrumb configuration
//   const breadcrumbItems = [
//     {
//       name: 'Home',
//      link: ':moduleHome'
//     },
//     {
//       name: t('Inventory Count'),
//       link: '/INV/InventoryCount'
//     },
//     {
//       name: isEditMode ? t('Edit Inventory Count') : t('Add New Inventory Count'),
//       link: null
//     }
//   ];

//   if (loading) {
//     return (
//       <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
//         <div className="spinner-border text-theme" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <>
//       <Breadcrumb
//         BreadcrumbList={breadcrumbItems}
//         PageName={isEditMode ? t('Edit Inventory Count') : t('Add New Inventory Count')}
//         subtitle={InventoryOptions?.find((f: any) => f.value === values.inventoryId)?.label}
//       />

//       <Card>
//         <Form onSubmit={formik.handleSubmit}>
//           <CardBody>
//             <div className='row'>
//               {/* Counting Type Display */}
//               <div className='col-lg-3'>
//                 <div className='form-group mb-3'>
//                   <label className='form-label'>{t('Counting Type')}</label>
//                   <div className='input-group'>
//                     <input
//                       type='text'
//                       className='form-control bg-light'
//                       value={getInventoryCountingTypeName()}
//                       readOnly
//                       placeholder={t('No counting type selected')}
//                     />
//                     {!isEditMode && (
//                       <button
//                         type="button"
//                         className="btn btn-theme"
//                         onClick={() => setShowModal(true)}
//                       >
//                         <i className="fas fa-edit"></i>
//                       </button>
//                     )}
//                   </div>
//                   <div className='form-text text-muted'>
//                     {values.inventoryCountingTypes === 'PhysicalInventory' && t('Full inventory - includes all items')}
//                     {values.inventoryCountingTypes === 'CycleCount' && t('Cycle count - manually select items')}
//                     {!values.inventoryCountingTypes && t('Select counting type from modal')}
//                   </div>
//                 </div>
//               </div>

//               {/* Local Name */}
//               <div className='col-xl-3'>
//                 <div className='form-group mb-3'>
//                   <label className='form-label'>{t('LocalName')}</label>
//                   <Form.Control
//                     className='form-control'
//                     type='text'
//                     autoComplete='off'
//                     name='name2'
//                     onChange={handleChange}
//                     value={values.name2}
//                     isInvalid={!!(touched.name2 && errors.name2)}
//                   />
//                   <Form.Control.Feedback type='invalid'>{errors.name2}</Form.Control.Feedback>
//                 </div>
//               </div>

//               {/* Global Name */}
//               <div className='col-xl-3'>
//                 <div className='form-group mb-3'>
//                   <label className='form-label'>{t('GlobalName')}</label>
//                   <Form.Control
//                     className='form-control'
//                     type='text'
//                     autoComplete='off'
//                     name='name'
//                     onChange={handleChange}
//                     value={values.name}
//                     isInvalid={!!(touched.name && errors.name)}
//                   />
//                   <Form.Control.Feedback type='invalid'>{errors.name}</Form.Control.Feedback>
//                 </div>
//               </div>

//               {/* Operating Unit */}
//               <div className='col-lg-3'>
//                 <div className='form-group mb-3'>
//                   <label className='form-label'>{t('OperatingUnit')}</label>
//                   <Select
//                     classNamePrefix='react-select'
//                     isLoading={loadingOU}
//                     isSearchable={true}
//                     isClearable={!isEditMode}
//                     options={OperatingUnitOptions}
//                     value={OperatingUnitOptions?.find((f: any) => f.value === values.branchId)}
//                     onChange={(option: any) => {
//                       setFieldValue('branchId', option?.value || '');
//                       if (!option) {
//                         setFieldValue('inventoryId', '');
//                       }
//                     }}
//                     placeholder={t('Choose')}
//                     isDisabled={isEditMode}
//                   />
//                 </div>
//               </div>

//               {/* Inventory */}
//               <div className='col-lg-3'>
//                 <div className='form-group mb-3'>
//                   <label className='form-label'>{t('Inventory')}</label>
//                   <Select
//                     classNamePrefix='react-select'
//                     isLoading={loadingInv}
//                     isSearchable={true}
//                     isClearable={!isEditMode}
//                     options={InventoryOptions?.filter((f: any) => f.operatingUnitId === values.branchId)}
//                     value={InventoryOptions.find((d: any) => d.value === values.inventoryId)}
//                     onChange={(option: any) => {
//                       setFieldValue('inventoryId', option?.value || '');
//                     }}
//                     placeholder={t('Choose')}
//                     isDisabled={!values.branchId || isEditMode}
//                   />
//                 </div>
//               </div>

//               {/* Start Date */}
//               <div className='col-lg-3'>
//                 <div className='form-group mb-3'>
//                   <label className='form-label'>{t('Start Date')}</label>
//                   <Form.Control
//                     className='form-control text-center'
//                     type='date'
//                     name='startDate'
//                     onChange={handleChange}
//                     value={values.startDate || ''}
//                     isInvalid={!!(touched.startDate && errors.startDate)}
//                   />
//                 </div>
//               </div>

//               {/* Freeze Date */}
//               <div className='col-lg-3'>
//                 <div className='form-group mb-3'>
//                   <label className='form-label'>{t('Freeze Date')}</label>
//                   <Form.Control
//                     className='form-control text-center'
//                     type='date'
//                     name='freezeDate'
//                     onChange={handleChange}
//                     value={values.freezeDate || ''}
//                     isInvalid={!!(touched.freezeDate && errors.freezeDate)}
//                   />
//                 </div>
//               </div>

//               {/* Immediately Checkbox */}
//               <div className='col-lg-2'>
//                 <div className='form-group mb-3'>
//                   <label className='form-label mb-4'></label>
//                   <div className='form-check'>
//                     <input
//                       className='form-check-input'
//                       type='checkbox'
//                       name='immediately'
//                       onChange={handleChange}
//                       checked={values.immediately}
//                     />
//                     <label className='form-check-label'>{t('Execute Immediately')}</label>
//                   </div>
//                 </div>
//               </div>

//               {/* Description */}
//               <div className='col-lg-12'>
//                 <div className='form-group mb-3'>
//                   <label className='form-label'>{t('Note')}</label>
//                   <Form.Control
//                     autoComplete='off'
//                     className='form-control'
//                     as='textarea'
//                     rows={3}
//                     name='description'
//                     onChange={handleChange}
//                     value={values.description}
//                     isInvalid={!!(touched.description && errors.description)}
//                   />
//                 </div>
//               </div>
//             </div>
//           </CardBody>
//           <CardFooter className='shadow-sm px-0'>
//             {/* Message for Physical Inventory */}
//             {values.inventoryCountingTypes === 'PhysicalInventory' && (
//               <div className='alert alert-info mt-3'>
//                 <div className='d-flex align-items-center'>
//                   <i className='fas fa-info-circle fa-2x me-3'></i>
//                   <div>
//                     <h6 className='alert-heading mb-1'>{t('Full Inventory')}</h6>
//                     <p className='mb-0'>{t('All items in the selected inventory will be counted automatically.')}</p>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* Items List for Cycle Count */}
//             {showItemsList && values.inventoryCountingTypes === 'CycleCount' && (
//             //   <ItemsList formik={formik} isEditMode={isEditMode} />
//               <ItemsList formik={formik}   />
//             )}

//             <div className='text-center mt-4'>
//               <button
//                 disabled={isSubmitting}
//                 type='submit'
//                 className='btn btn-lg me-3 btn-theme mb-1'
//               >
//                 {isSubmitting ? (
//                   <div className='spinner-border spinner-border-sm me-2'></div>
//                 ) : (
//                   <i className={`fas fa-lg fa-fw me-2 ${isEditMode ? 'fa-save' : 'fa-plus'}`}></i>
//                 )}
//                 {isEditMode ? t('Update') : t('Add')}
//               </button>
//               <button
//                 type='button'
//                 className='btn btn-lg btn-outline-secondary mb-1'
//                 onClick={() => navigate(-1)}
//               >
//                 <i className='fa fa-times fa-fw me-1'></i> {t('Cancel')}
//               </button>
//             </div>
//           </CardFooter>
//         </Form>
//       </Card>

//       {/* Selection Modal - Only for Add mode */}
//       {!isEditMode && (
//         <Modal show={showModal} backdrop='static' keyboard={false} centered className='modal-selection-theme'>
//           <Modal.Header className='bg-theme bg-opacity-30 text-white py-3'>
//             <Modal.Title className='text-center w-100 h5'>
//               <i className='fas fa-warehouse me-2'></i>
//               {t('Select Operating Unit & Inventory')}
//             </Modal.Title>
//           </Modal.Header>

//           <Modal.Body className='p-4'>
//             <div className='text-center mb-4'>
//               <div
//                 className='bg-secondary bg-opacity-35 rounded-circle d-inline-flex align-items-center justify-content-center mb-3'
//                 style={{ width: '70px', height: '70px' }}
//               >
//                 <i className='fas fa-clipboard-list fs-2 text-theme'></i>
//               </div>
//               <p className='text-muted mb-0'>{t('Please select operating unit, inventory and counting type')}</p>
//             </div>

//             <div className='row'>
//               {/* Counting Type Selection */}
//               <div className='col-12 mb-4'>
//                 <label className='form-label fw-bold'>{t('Counting Type')}</label>
//                 <div className='d-flex gap-2'>
//                   <input
//                     type='radio'
//                     className='btn-check'
//                     name='inventoryCountingTypes'
//                     id='inventoryTypePhysical'
//                     value='PhysicalInventory'
//                     checked={values.inventoryCountingTypes === 'PhysicalInventory'}
//                     onChange={handleChange}
//                   />
//                   <label
//                     className={`btn flex-fill ${values.inventoryCountingTypes === 'PhysicalInventory' ? 'btn-theme' : 'btn-outline-theme'}`}
//                     htmlFor='inventoryTypePhysical'
//                   >
//                     <i className='fas fa-boxes me-2'></i>
//                     {t('Physical Inventory')}
//                   </label>

//                   <input
//                     type='radio'
//                     className='btn-check'
//                     name='inventoryCountingTypes'
//                     id='inventoryTypeCycle'
//                     value='CycleCount'
//                     checked={values.inventoryCountingTypes === 'CycleCount'}
//                     onChange={handleChange}
//                   />
//                   <label
//                     className={`btn flex-fill ${values.inventoryCountingTypes === 'CycleCount' ? 'btn-theme' : 'btn-outline-theme'}`}
//                     htmlFor='inventoryTypeCycle'
//                   >
//                     <i className='fas fa-list-check me-2'></i>
//                     {t('Cycle Count')}
//                   </label>
//                 </div>
//               </div>

//               {/* Operating Unit */}
//               <div className='col-12 mb-4'>
//                 <label className='form-label fw-bold'>{t('OperatingUnit')}</label>
//                 <Select
//                   classNamePrefix='react-select'
//                   isSearchable
//                   isClearable
//                   options={OperatingUnitOptions}
//                   value={OperatingUnitOptions?.find((f: any) => f.value === values.branchId)}
//                   onChange={(option: any) => {
//                     setFieldValue('branchId', option?.value || '');
//                     setFieldValue('inventoryId', '');
//                   }}
//                   placeholder={t('Choose')}
//                   isLoading={loadingOU}
//                 />
//               </div>

//               {/* Inventory */}
//               <div className='col-12 mb-4'>
//                 <label className='form-label fw-bold'>{t('Inventory')}</label>
//                 <Select
//                   classNamePrefix='react-select'
//                   isSearchable
//                   isClearable
//                   options={InventoryOptions?.filter((f: any) => f.operatingUnitId === values.branchId)}
//                   value={InventoryOptions?.find((f: any) => f.value === values.inventoryId)}
//                   onChange={option => setFieldValue('inventoryId', option?.value || '')}
//                   placeholder={t('Choose')}
//                   isDisabled={!values.branchId}
//                   isLoading={loadingInv}
//                 />
//               </div>
//             </div>

//             {/* Info Messages */}
//             {values.inventoryCountingTypes === 'PhysicalInventory' && (
//               <div className='alert alert-info mt-3'>
//                 <i className='fas fa-info-circle me-2'></i>
//                 {t('All items in the selected inventory will be counted automatically.')}
//               </div>
//             )}

//             {values.inventoryCountingTypes === 'CycleCount' && (
//               <div className='alert alert-warning mt-3'>
//                 <i className='fas fa-exclamation-circle me-2'></i>
//                 {t('You will manually select items to count after closing this window.')}
//               </div>
//             )}
//           </Modal.Body>

//           <Modal.Footer className='justify-content-center border-top-0 pt-0'>
//             <button
//               className='btn btn-outline-secondary btn-lg px-4'
//               onClick={() => navigate('/INV/InventoryCount')}
//             >
//               <i className='fas fa-times me-2'></i>
//               {t('Cancel')}
//             </button>
//             <button
//               className='btn btn-theme btn-lg px-5'
//               onClick={handleSubmitModal}
//               disabled={!values.branchId || !values.inventoryId || !values.inventoryCountingTypes}
//             >
//               <i className='fas fa-check-circle me-2'></i>
//               {t('Continue')}
//             </button>
//           </Modal.Footer>
//         </Modal>
//       )}
//     </>
//   );
// };

// export default InventoryCountForm;

import { useFormik } from 'formik';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import Select from 'react-select';
import { Card, CardFooter } from '@components/card/card';
import { CardBody, Form, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { useNavigate, useParams } from 'react-router-dom';
import ItemsList from './ItemsList/ItemsList';
import {
  addInventoryCount,
  updatInventoryCount,
  getInventoryCountById
} from '@store/INV/InventoryCount/inventoryCountSlice';
import { useEffect, useMemo, useState } from 'react';
import ToastSwal from '@components/Shared/Alert/ToastSwal';
import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';
import { getPersonId } from '@store/Login/authSelectors';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import useLookupInventoryCountingTypes from '@hooks/Lookups/use-Lookup-InventoryCountingTypes';

const InventoryCountForm = () => {
  const { id } = useParams(); // ID for update
  const isEditMode = Boolean(id);

  const [showModal, setShowModal] = useState(!isEditMode);
  const [loadingData, setLoadingData] = useState(isEditMode);
  const [initialData, setInitialData] = useState<any>(null);

  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const Navigate = useNavigate();
  const personId = useAppSelector(getPersonId);

  const { InventoryCountingTypes } = useLookupInventoryCountingTypes();

  const { OperatingUnitOptions, loading: loading1, error: error1 } = useGetOperatingUnitWithPermission();
  const { InventoryOptions, loading: loading3 } = useGetInventoryWithPermission();

  const [showItemsList, setShowItemsList] = useState(false);

  // Fetch data for edit mode
  useEffect(() => {
    if (isEditMode && id) {

      const fetchData = async () => {
        try {
          setLoadingData(true);
          const result = await dispatch(getInventoryCountById(id)).unwrap();
          
          if (result?.succeeded) {
            setInitialData(result.data);
          } else {
            CustomAlert({ action: 'Error', msg: result?.message || 'فشل في تحميل البيانات' });
            Navigate('/INV/InventoryCount');
          }
        } catch (error) {
          CustomAlert({ action: 'Error' });
          Navigate('/INV/InventoryCount');
        } finally {
          setLoadingData(false);
        }
      };

      fetchData();
    }
  }, [isEditMode, id, dispatch, Navigate]);

  // Initialize form values
  const getInitialValues = () => {
    if (isEditMode && initialData) {
      return {
        name: initialData.name || '',
        name2: initialData.name2 || '',
        personId: initialData.personId || personId,
        inventoryId: initialData.inventoryId || '',
        branchId: initialData.branchId || '',
        startDate: initialData.startDate || '',
        description: initialData.description || '',
        freezeDate: initialData.freezeDate || '',
        immediately: initialData.immediately || false,
        inventoryCountingTypes: initialData.inventoryCountingTypes || '',
        inventoryCountItemsList: initialData.inventoryCountItemsList || []
      };
    }

    return {
      name: '',
      name2: '',
      personId: personId,
      inventoryId: '',
      branchId: '',
      startDate: '',
      description: '',
      freezeDate: '',
      immediately: false,
      inventoryCountingTypes: '',
      inventoryCountItemsList: [] as any[]
    };
  };

  //#region Formik
  const formik = useFormik({
    initialValues: getInitialValues(),
    enableReinitialize: true,
    onSubmit: values => {
      const itemsList =
        values.inventoryCountingTypes === 'PhysicalInventory'
          ? []
          : values.inventoryCountItemsList?.map((item :any) => ({
              id: item.id || null,
              inventoryItemId: item.inventoryItemId,
              systemQuantity: item.systemQuantity,
              description: item.description,
              subInventoryId: item.subInventoryId
            }));

      const action = isEditMode
        ? updatInventoryCount({ id, ...values, inventoryCountItemsList: itemsList })
        : addInventoryCount({
            name: values.name,
            name2: values.name2,
            personId: values.personId || null,
            inventoryId: values.inventoryId,
            branchId: values.branchId,
            startDate: values.startDate,
            description: values.description,
            freezeDate: values.freezeDate,
            immediately: values.immediately,
            inventoryCountingTypes: values.inventoryCountingTypes,
            inventoryCountItemsList: itemsList
          });

      dispatch(action)
        .unwrap()
        .then((res: any) => {
          if (res?.succeeded === true) {
            CustomAlert({ action: isEditMode ? 'Edit' : 'Add' });
            Navigate(-1);
          } else {
            formik.setSubmitting(false);
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch((error: any) => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    }
  });

  const { values, handleChange: formikhandleChange, errors, touched, setFieldValue } = formik;
  //#endregion

  // تحديد وحدة التشغيل الأولى تلقائيًا عند تحميل البيانات (للوضع الإضافة فقط)
  useEffect(() => {
    if (!isEditMode && !formik.values.branchId && OperatingUnitOptions?.length > 0) {
      const firstOption = OperatingUnitOptions[0];
      formik.setFieldValue('branchId', firstOption.value);
    }
  }, [OperatingUnitOptions, isEditMode]);

  // التحكم في عرض قائمة الأصناف بناءً على نوع الجرد
  useEffect(() => {
    if (values.inventoryCountingTypes === 'CycleCount') {
      setShowItemsList(true);
      if (!values.inventoryCountItemsList || values.inventoryCountItemsList.length === 0) {
        setFieldValue('inventoryCountItemsList', [
          {
            inventoryItemId: null,
            systemQuantity: 0,
            description: ''
          }
        ]);
      }
    } else if (values.inventoryCountingTypes === 'PhysicalInventory') {
      setShowItemsList(false);
      setFieldValue('inventoryCountItemsList', []);
    }
  }, [values.inventoryCountingTypes, setFieldValue]);

  const handleSubmitModal = async () => {
    if (formik.values.branchId && formik.values.inventoryId && formik.values.inventoryCountingTypes) {
      setShowModal(false);
    } else {
      ToastSwal({ title: 'يرجى اختيار وحدة التشغيل والمخزن ونوع الجرد', timer: 1000 });
    }
  };

  // دالة للحصول على اسم نوع الجرد
  const getInventoryCountingTypeName = () => {
    if (!values.inventoryCountingTypes) return '';

    let typeName = '';
    InventoryCountingTypes?.forEach((item: any) => {
      item.list?.forEach((list: any) => {
        if (list.lookupCode === values.inventoryCountingTypes) {
          typeName = i18n.language === 'ar' ? list.meaning2 : list.meaning;
        }
      });
    });
    return typeName;
  };

  const isLoading = useMemo(() => loading1 || loading3 || loadingData, [loading1, loading3, loadingData]);

  // Show loading while fetching data for edit
  if (loadingData) {
    return (
      <div className='d-flex justify-content-center align-items-center' style={{ height: '50vh' }}>
        <div className='spinner-border text-theme' role='status'>
          <span className='visually-hidden'>Loading...</span>
        </div>
      </div>
    );
  }

//   console.log(values);

  return (
    <>
      <Breadcrumb
        BreadcrumbList={[
          {
            name: 'Home',
           link: ':moduleHome'
          },
          {
            name: 'جرد المخزون',
            link: '/INV/InventoryCount'
          },
          {
            name: isEditMode ? 'تعديل الجرد' : 'إضافة جرد جديد',
            link: null
          }
        ]}
        PageName={isEditMode ? 'تعديل الجرد' : 'إضافة جرد جديــد'}
        subtitle={InventoryOptions?.find((f: any) => f.value === values.inventoryId)?.label}
      />

      <Card>
        <Form onSubmit={formik.handleSubmit}>
          <CardBody>
            <div className='row'>
              <div className='col-lg-3'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('نوع الجرد')}</label>
                  <div className='input-group'>
                    <input
                      type='text'
                      className='form-control bg-light'
                      value={getInventoryCountingTypeName()}
                      readOnly
                      placeholder='لم يتم اختيار نوع الجرد'
                    />
                    {!isEditMode && (
                      <button type='button' className='btn btn-theme' onClick={() => setShowModal(true)}>
                        <i className='fas fa-edit'></i>
                      </button>
                    )}
                  </div>
                  <div className='form-text text-muted'>
                    {values.inventoryCountingTypes === 'PhysicalInventory' && 'جرد شامل - يشمل جميع الأصناف'}
                    {values.inventoryCountingTypes === 'CycleCount' && 'جرد دوري - تحديد الأصناف يدويًا'}
                    {!values.inventoryCountingTypes && 'اختر نوع الجرد من المودال'}
                  </div>
                </div>
              </div>

              <div className='col-xl-3'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('LocalName')}</label>
                  <Form.Control
                    className='form-control'
                    type='text'
                    autoComplete='off'
                    name='name2'
                    onChange={formik.handleChange}
                    value={formik.values.name2}
                    isInvalid={!!(formik.touched.name2 && formik.errors.name2)}
                  />
                  <Form.Control.Feedback type='invalid'>{formik.errors.name as any}</Form.Control.Feedback>
                </div>
              </div>

              <div className='col-xl-3'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('GlobalName')}</label>
                  <Form.Control
                    className='form-control'
                    type='text'
                    autoComplete='off'
                    name='name'
                    onChange={formik.handleChange}
                    value={formik.values.name}
                    isInvalid={!!(formik.touched.name && formik.errors.name)}
                  />
                  <Form.Control.Feedback type='invalid'>{formik.errors.name2 as any}</Form.Control.Feedback>
                </div>
              </div>

              <div className='col-lg-3'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('OperatingUnit')}</label>
                  <Select
                    classNamePrefix='react-select'
                    isLoading={loading1}
                    isSearchable={true}
                    isClearable={!isEditMode}
                    options={OperatingUnitOptions}
                    value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.branchId)}
                    onChange={(option: any) => {
                      formik.setFieldValue('branchId', option === null ? null : option.value);
                      if (!option) {
                        formik.setFieldValue('inventoryId', '');
                      }
                    }}
                    placeholder={t('Choose')}
                    isDisabled={isEditMode}
                  />
                </div>
              </div>

              <div className='col-lg-3'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('Inventory')}</label>
                  <Select
                    classNamePrefix='react-select'
                    isLoading={loading3}
                    isSearchable={true}
                    isClearable={!isEditMode}
                    options={InventoryOptions?.filter((f: any) => f.operatingUnitId === formik.values.branchId)}
                    value={InventoryOptions.find((d: any) => d.value === values.inventoryId)}
                    onChange={(option: any) => {
                      formik.setFieldValue('inventoryId', option === null ? null : option.value);
                    }}
                    placeholder={t('Choose')}
                    isDisabled={!formik.values.branchId || isEditMode}
                  />
                </div>
              </div>

              <div className='col-lg-3'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('تاريخ بداية الجرد')}</label>
                  <Form.Control
                    className='form-control  text-center'
                    type='date'
                    name='startDate'
                    onChange={formikhandleChange}
                    value={values.startDate || ''}
                    isInvalid={!!(touched.startDate && errors.startDate)}
                  />
                </div>
              </div>

              <div className='col-lg-3'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('تاريخ التجميد')}</label>
                  <Form.Control
                    className='form-control  text-center'
                    type='date'
                    name='freezeDate'
                    onChange={formikhandleChange}
                    value={values.freezeDate || ''}
                    isInvalid={!!(touched.freezeDate && errors.freezeDate)}
                  />
                </div>
              </div>

              <div className='col-lg-2 '>
                <div className='form-group mb-3'>
                  <label className='form-label mb-4'></label>
                  <div className='form-check '>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      name='immediately'
                      onChange={formik.handleChange}
                      checked={values.immediately}
                    />
                    <label className='form-check-label'>تنفيذ فوري</label>
                  </div>
                </div>
              </div>

              <div className='col-lg-12'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('Note')}</label>
                  <Form.Control
                    autoComplete='off'
                    className='form-control'
                    as='textarea'
                    rows={1}
                    name='description'
                    onChange={formik.handleChange}
                    value={values.description}
                    isInvalid={!!(touched.description && errors.description)}
                  />
                </div>
              </div>
            </div>
          </CardBody>
          <CardFooter className='shadow-sm px-0  '>
            {/* رسالة عندما يكون نوع الجرد PhysicalInventory */}
            {values.inventoryCountingTypes === 'PhysicalInventory' && (
              <div className='alert alert-info mt-3'>
                <div className='d-flex align-items-center'>
                  <i className='fas fa-info-circle fa-2x me-3'></i>
                  <div>
                    <h6 className='alert-heading mb-1'>جرد شامل</h6>
                    <p className='mb-0'>سيتم جرد جميع الأصناف الموجودة في المخزن المحدد تلقائيًا.</p>
                  </div>
                </div>
              </div>
            )}
            {/* عرض قائمة الأصناف فقط لنوع CycleCount */}
            {showItemsList && values.inventoryCountingTypes === 'CycleCount' && (
              <>
                {/* <ItemsList formik={formik} isEditMode={isEditMode} /> */}
                <ItemsList formik={formik} />
              </>
            )}

            <div className='text-center mt-2'>
              <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg me-1 btn-theme mb-1'>
                {formik.isSubmitting ? (
                  <div className='spinner-border spinner-border-sm me-2'></div>
                ) : (
                  <i className={`fas fa-lg fa-fw me-2 ${isEditMode ? 'fa-save' : 'fa-plus'}`}></i>
                )}
                {isEditMode ? 'تحديث' : t('Add')}
              </button>
              <button type='button' className='btn btn-lg  me-1 btn-default mb-1' onClick={() => Navigate(-1)}>
                <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
              </button>
            </div>
          </CardFooter>
        </Form>
      </Card>

      {/* المودال المعدل بإضافة نوع الجرد - يظهر فقط في وضع الإضافة */}
      {!isEditMode && (
        <Modal show={showModal} backdrop='static' keyboard={false} centered className='modal-selection-theme'>
          <Modal.Header className='bg-theme bg-opacity-30 text-white py-3'>
            <Modal.Title className='text-center w-100 h5'>
              <i className='fas fa-warehouse me-2'></i>
              {t('SelectOperatingUnitInventory')}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className='p-4'>
            <div className='text-center mb-4'>
              <div
                className='bg-secondary bg-opacity-35 rounded-circle d-inline-flex align-items-center justify-content-center mb-3'
                style={{ width: '70px', height: '70px' }}
              >
                <i className='fas fa-clipboard-list fs-2 text-theme'></i>
              </div>
              <p className='text-muted mb-0'>{t('PleaseSelectOperatingUnitInventory')}</p>
            </div>

            <div className='row'>
              {/* نوع الجرد - بنفس شكل نوع الفاتورة */}
              <div className='col-12 mb-4'>
                <label className='form-label fw-bold'>{t('نوع الجرد')}</label>
                <div className='input-group'>
                  <span className='input-group-text bg-theme bg-opacity-10 border-end-0'>
                    <i className='fas fa-clipboard-check text-theme'></i>
                  </span>
                  <div className='d-flex gap-2 p-2 border rounded flex-grow-1' style={{ minHeight: '44px' }}>
                    {/* زر الجرد الشامل */}
                    <input
                      type='radio'
                      className='btn-check'
                      name='inventoryCountingTypes'
                      id='inventoryTypePhysical'
                      value='PhysicalInventory'
                      checked={formik.values.inventoryCountingTypes === 'PhysicalInventory'}
                      onChange={formik.handleChange}
                      autoComplete='off'
                    />
                    <label
                      className={`btn btn-sm ${
                        formik.values.inventoryCountingTypes === 'PhysicalInventory' ? 'btn-theme' : 'btn-outline-theme'
                      } flex-fill d-flex align-items-center justify-content-center`}
                      htmlFor='inventoryTypePhysical'
                      style={{ borderRadius: '1px', transition: 'all 0.3s ease' }}
                    >
                      <i className='fas fa-boxes me-2'></i>
                      {/* {t('PhysicalInventory')} */}
                      الجرد الفعلي او السنوي
                    </label>

                    {/* زر الجرد الدوري */}
                    <input
                      type='radio'
                      className='btn-check'
                      name='inventoryCountingTypes'
                      id='inventoryTypeCycle'
                      value='CycleCount'
                      checked={formik.values.inventoryCountingTypes === 'CycleCount'}
                      onChange={formik.handleChange}
                      autoComplete='off'
                    />
                    <label
                      className={`btn btn-sm ${
                        formik.values.inventoryCountingTypes === 'CycleCount' ? 'btn-theme' : 'btn-outline-theme'
                      } flex-fill d-flex align-items-center justify-content-center`}
                      htmlFor='inventoryTypeCycle'
                      style={{ borderRadius: '1px', transition: 'all 0.3s ease' }}
                    >
                      <i className='fas fa-list-check me-2'></i>
                      {/* {t('CycleCount')} */}
                      الجرد الدوري
                    </label>
                  </div>
                </div>
                {!formik.values.inventoryCountingTypes && (
                  <div className='form-text text-info mt-2'>
                    <i className='fas fa-info-circle me-1'></i>
                    اختر نوع الجرد أولاً
                  </div>
                )}
              </div>

              {/* وحدة التشغيل */}
              <div className='col-12 mb-4'>
                <label className='form-label fw-bold'>{t('OperatingUnit')}</label>
                <div className='input-group'>
                  <span className='input-group-text bg-theme bg-opacity-10 border-end-0'>
                    <i className='fas fa-building text-theme'></i>
                  </span>
                  <Select
                    classNamePrefix='react-select'
                    isSearchable
                    isClearable
                    options={OperatingUnitOptions}
                    value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.branchId)}
                    onChange={(option: any) => {
                      formik.setFieldValue('branchId', option?.value || '');
                      formik.setFieldValue('inventoryId', '');
                    }}
                    placeholder={t('Choose')}
                    className='flex-grow-1'
                    isLoading={loading1}
                  />
                </div>
                {!formik.values.branchId && (
                  <div className='form-text text-info mt-2'>
                    <i className='fas fa-info-circle me-1'></i>
                    اختر الوحدة التشغيلية أولاً لتمكين اختيار المخزن
                  </div>
                )}
              </div>

              {/* المخزن */}
              <div className='col-12 mb-4'>
                <label className='form-label fw-bold'>{t('Inventory')}</label>
                <div className='input-group'>
                  <span className='input-group-text bg-theme bg-opacity-10 border-end-0'>
                    <i className='fas fa-boxes text-theme'></i>
                  </span>
                  <Select
                    classNamePrefix='react-select'
                    isSearchable
                    isClearable
                    options={InventoryOptions?.filter((f: any) => f.operatingUnitId === formik.values.branchId)}
                    value={InventoryOptions?.find((f: any) => f.value === formik.values.inventoryId)}
                    onChange={option => formik.setFieldValue('inventoryId', option?.value || '')}
                    placeholder={t('Choose')}
                    isDisabled={!formik.values.branchId}
                    className='flex-grow-1'
                    isLoading={loading3}
                  />
                </div>
              </div>
            </div>

            {/* رسائل توضيحية لأنواع الجرد داخل المودال */}
            {formik.values.inventoryCountingTypes === 'PhysicalInventory' && (
              <div className='alert alert-info mt-3'>
                <div className='d-flex align-items-center'>
                  <i className='fas fa-info-circle me-3'></i>
                  <div>
                    <h6 className='alert-heading mb-1'>جرد سنوي</h6>
                    <p className='mb-0'>سيتم جرد جميع الأصناف الموجودة في المخزن المحدد تلقائيًا.</p>
                  </div>
                </div>
              </div>
            )}

            {formik.values.inventoryCountingTypes === 'CycleCount' && (
              <div className='alert alert-warning mt-3'>
                <div className='d-flex align-items-center'>
                  <i className='fas fa-exclamation-circle me-3'></i>
                  <div>
                    <h6 className='alert-heading mb-1'>جرد دوري</h6>
                    <p className='mb-0'>سيتم تحديد الأصناف المراد جردها يدويًا بعد إغلاق هذه النافذة.</p>
                  </div>
                </div>
              </div>
            )}
          </Modal.Body>

          <Modal.Footer className='justify-content-center border-top-0 pt-0'>
            <button
              className='btn btn-outline-secondary btn-lg px-4 py-2 me-3'
              onClick={() => Navigate('/INV/InventoryCount')}
            >
              <i className='fas fa-times me-2'></i>
              {t('Cancel')}
            </button>
            <button
              className='btn btn-theme btn-lg px-5 py-2'
              onClick={handleSubmitModal}
              disabled={!formik.values.branchId || !formik.values.inventoryId || !formik.values.inventoryCountingTypes}
            >
              <i className='fas fa-check-circle me-2'></i>
              {t('Continue')}
            </button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default InventoryCountForm;
